import React from 'react';
import PropTypes from 'prop-types';
import { constructCn } from '../../../utilities/helperFunctions';

import './Dots.scss';

const Dots = ({ className, isActive }) => {
    const cn = constructCn(
        'component-Dots',
        className,
        isActive && 'active',
        !isActive && 'inactive'
    );
    return (
        <div className={cn}>
            <svg
                width="30px"
                height="30px"
                viewBox="0 0 30 30"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g
                    id="Feed/•••"
                    stroke="none"
                    strokeWidth="1"
                    fill="none"
                    fillRule="evenodd"
                >
                    <g>
                        <rect
                            id="Rectangle"
                            x="0"
                            y="0"
                            width="30"
                            height="30"
                        />
                        <path
                            d="M10.4965596,16 C10.7029817,16 10.8979358,15.9607843 11.081422,15.8823529 C11.2649083,15.8039216 11.4243119,15.6966551 11.559633,15.5605536 C11.6949541,15.4244521 11.8021789,15.2658593 11.8813073,15.0847751 C11.9604358,14.9036909 12,14.710496 12,14.5051903 C12,14.2975779 11.9604358,14.1026528 11.8813073,13.9204152 C11.8021789,13.7381776 11.6949541,13.5784314 11.559633,13.4411765 C11.4243119,13.3039216 11.2649083,13.1960784 11.081422,13.1176471 C10.8979358,13.0392157 10.7029817,13 10.4965596,13 C10.2901376,13 10.0963303,13.0392157 9.91513761,13.1176471 C9.73394495,13.1960784 9.57568807,13.3039216 9.44036697,13.4411765 C9.30504587,13.5784314 9.1978211,13.7381776 9.11869266,13.9204152 C9.03956422,14.1026528 9,14.2975779 9,14.5051903 C9,14.710496 9.03956422,14.9036909 9.11869266,15.0847751 C9.1978211,15.2658593 9.30504587,15.4244521 9.44036697,15.5605536 C9.57568807,15.6966551 9.73394495,15.8039216 9.91513761,15.8823529 C10.0963303,15.9607843 10.2901376,16 10.4965596,16 Z M15.4965596,16 C15.7029817,16 15.8979358,15.9607843 16.081422,15.8823529 C16.2649083,15.8039216 16.4243119,15.6966551 16.559633,15.5605536 C16.6949541,15.4244521 16.8021789,15.2658593 16.8813073,15.0847751 C16.9604358,14.9036909 17,14.710496 17,14.5051903 C17,14.2975779 16.9604358,14.1026528 16.8813073,13.9204152 C16.8021789,13.7381776 16.6949541,13.5784314 16.559633,13.4411765 C16.4243119,13.3039216 16.2649083,13.1960784 16.081422,13.1176471 C15.8979358,13.0392157 15.7029817,13 15.4965596,13 C15.2901376,13 15.0963303,13.0392157 14.9151376,13.1176471 C14.733945,13.1960784 14.5756881,13.3039216 14.440367,13.4411765 C14.3050459,13.5784314 14.1978211,13.7381776 14.1186927,13.9204152 C14.0395642,14.1026528 14,14.2975779 14,14.5051903 C14,14.710496 14.0395642,14.9036909 14.1186927,15.0847751 C14.1978211,15.2658593 14.3050459,15.4244521 14.440367,15.5605536 C14.5756881,15.6966551 14.733945,15.8039216 14.9151376,15.8823529 C15.0963303,15.9607843 15.2901376,16 15.4965596,16 Z M20.4965596,16 C20.7029817,16 20.8979358,15.9607843 21.081422,15.8823529 C21.2649083,15.8039216 21.4243119,15.6966551 21.559633,15.5605536 C21.6949541,15.4244521 21.8021789,15.2658593 21.8813073,15.0847751 C21.9604358,14.9036909 22,14.710496 22,14.5051903 C22,14.2975779 21.9604358,14.1026528 21.8813073,13.9204152 C21.8021789,13.7381776 21.6949541,13.5784314 21.559633,13.4411765 C21.4243119,13.3039216 21.2649083,13.1960784 21.081422,13.1176471 C20.8979358,13.0392157 20.7029817,13 20.4965596,13 C20.2901376,13 20.0963303,13.0392157 19.9151376,13.1176471 C19.733945,13.1960784 19.5756881,13.3039216 19.440367,13.4411765 C19.3050459,13.5784314 19.1978211,13.7381776 19.1186927,13.9204152 C19.0395642,14.1026528 19,14.2975779 19,14.5051903 C19,14.710496 19.0395642,14.9036909 19.1186927,15.0847751 C19.1978211,15.2658593 19.3050459,15.4244521 19.440367,15.5605536 C19.5756881,15.6966551 19.733945,15.8039216 19.9151376,15.8823529 C20.0963303,15.9607843 20.2901376,16 20.4965596,16 Z"
                            id="•••"
                            fill="#8E9DB9"
                            fillRule="nonzero"
                            transform="translate(15.500000, 14.500000) rotate(-270.000000) translate(-15.500000, -14.500000) "
                        />
                    </g>
                </g>
            </svg>
        </div>
    );
};

Dots.propTypes = {
    className: PropTypes.string,
    isActive: PropTypes.bool,
};

Dots.defaultProps = {
    className: '',
    isActive: false,
};

Dots.displayName = 'Dots';

export default Dots;
